/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react'
import {
  makeStyles,
  Typography,
  Badge,
  Tooltip,
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { TreeItem } from '@material-ui/lab'
import InfoIcon from '@material-ui/icons/InfoOutlined'

const useStyle = makeStyles((theme) => ({
  badge: {
    right: -10,
  },
  container: ({ downXs }) => ({
    display: downXs ? '' : 'flex',
    alignItems: 'baseline',
  }),
  value: {
    ...theme.typography.h5,
    marginLeft: theme.spacing(4),
  },
}))

const CriteriaTreeItem = ({ criteria, label, explanation, ...props }) => {
  const theme = useTheme()
  const downXs = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyle({ downXs })

  const getAriaLabel = () => `${label} ${explanation}`

  return (
    <TreeItem
      endIcon={<InfoIcon />}
      aria-label={getAriaLabel()}
      tabIndex="0"
      label={
        <Box key={criteria.name} className={classes.container}>
          <Tooltip title={explanation} placement="right-start">
            <Badge
              color="primary"
              badgeContent="i"
              classes={{ badge: classes.badge }}
            >
              <Typography className={classes.name} variant="h4">
                {label}
              </Typography>
            </Badge>
          </Tooltip>
          {criteria.criteria_type === 'radio_extended' && !downXs && (
            <span className={classes.value}>
              {criteria.choices[0].choice_label}
            </span>
          )}
        </Box>
      }
      {...props}
    />
  )
}

export default CriteriaTreeItem
